import { resetGatewaysState } from '@modules/gateways/stores/gateways.thunks'
import { useProjectsStore } from '@modules/projects/stores/projects.store'

import type { Project } from '../projects.type'

export function switchCurrentProject(project: Project): void {
  const previousId = useProjectsStore.getState().currentProject?.projectId
  if (previousId !== project.projectId) {
    resetGatewaysState()
  }
  useProjectsStore.getState().setCurrentProject(project)
}
